<template>
  <Template2 v-if="$event.Config.Template === '2'" />
  <Template1 v-else />
</template>

<script setup>
  import { ref, inject } from 'vue'
  import Template1 from './1/index.vue'
  import Template2 from './2/index.vue'
  const $event = inject('$event')
</script>
